import Model from '@/store/plugins/orm/Model'

export class Role extends Model {
    static get entity() {
        return 'roles';
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            permissions: this.attr([])
        };
    }
}

export default Role
